export const notificationCloseAnimationMs = 180;
export const notificationAutoCloseMs = {
  success: 5000,
  error: 10000,
  warning: 10000,
} as const;

export function normalizeProgress(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(100, Math.max(0, value));
}

export function createNotificationId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `notification-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
